var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchClient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9993 60.0006C73.5723 60.0006 81.3327 52.2403 81.3327 42.6673C81.3327 33.0944 73.5723 25.334 63.9993 25.334C54.4264 25.334 46.666 33.0944 46.666 42.6673C46.666 52.2403 54.4264 60.0006 63.9993 60.0006Z",
    fill: "#F5BDB2",
    stroke: "#F2D6D0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3325 102.666H37.0633C30.7727 102.666 26.0786 97.121 29.2837 91.7082C33.9323 83.8575 43.9424 74.666 65.3325 74.666",
    fill: "#F5BDB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3325 102.666H37.0633C30.7727 102.666 26.0786 97.121 29.2837 91.7082C33.9323 83.8575 43.9424 74.666 65.3325 74.666",
    stroke: "#F2D6D0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.667 102.667L84 84",
    stroke: "#F2D6D0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84 102.667L102.667 84",
    stroke: "#F2D6D0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchClient);
export default __webpack_public_path__ + "static/media/SearchClient.65c595a3e271a08ce2fda470adf6d90f.svg";
export { ForwardRef as ReactComponent };